import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes, LINE_ITEM_HOUR, LINE_ITEM_MINUTE, LINE_ITEM_TWO_DAYS, LINE_ITEM_PER_WEEK, LINE_ITEM_TWENTY_EIGHT_DAYS } from '../../util/types';

import css from './OrderBreakdown.module.css';
import classNames from 'classnames';


const LineItemBasePriceMaybe = props => {
  const { lineItems, code, intl, lineItemClass } = props;
  const newCode = code?.includes(':');
  const updatedCode = !newCode ? code : `line-item/${code.split('-').reverse()[0]}`

  const isNightly = updatedCode === LINE_ITEM_NIGHT;
  const isDaily = [LINE_ITEM_DAY, LINE_ITEM_TWO_DAYS, LINE_ITEM_PER_WEEK, LINE_ITEM_TWENTY_EIGHT_DAYS].includes(updatedCode);
  const isHourly = updatedCode === LINE_ITEM_HOUR;
  const isMinute = updatedCode === LINE_ITEM_MINUTE;

  const translationKey = isNightly
    ? 'OrderBreakdown.baseUnitNight'
    : isDaily
      ? 'OrderBreakdown.baseUnitDay'
      : isHourly
        ? 'OrderBreakdown.baseUnitHour'
        : isMinute
          ? 'OrderBreakdown.baseUnitMinute'
                : 'OrderBreakdown.baseUnitQuantity';

  // Find correct line-item for given code prop.
  // It should be one of the following: 'line-item/night, 'line-item/day', 'line-item/hour', or 'line-item/item'
  // These are defined in '../../util/types';
  const unitPurchase = lineItems.find(item => item.code === code && !item.reversal);

  // const quantity = unitPurchase ? unitPurchase.quantity.toString() : null;
  const quantity = unitPurchase?.units
    ? unitPurchase.units.toFixed(2)
    : unitPurchase?.quantity
      ? unitPurchase.quantity.toFixed(2)
      : null;
  const unitPrice = unitPurchase ? formatMoney(intl, unitPurchase.unitPrice) : null;
  const total = unitPurchase ? formatMoney(intl, unitPurchase.lineTotal) : null;

  const titleMaybe = code.split(':')[1] ? <p className={css.itemLabelText}>{code.split(':')[1]}</p> : null;
  const message = unitPurchase?.seats > 1
    ? (<FormattedMessage id={`${translationKey}Seats`} values={{ unitPrice, quantity, seats: unitPurchase.seats }} />)
    : (<FormattedMessage id={translationKey} values={{ unitPrice, quantity }} />)

  return quantity && total ? (
    <div className={classNames(css.lineItem, lineItemClass)}>
      <div className={css.itemLabel}>
        <div>
          {titleMaybe}
          <div className={css.messageText}>{message}</div>
        </div>
      </div>
      <span className={css.itemValue}>{total}</span>
    </div>
  ) : null;
};

LineItemBasePriceMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  // code: propTypes.lineItemUnitType.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemBasePriceMaybe;
